import React from 'react';
import { IntlProvider } from 'react-intl';
import { useSelector } from 'react-redux'
import { translations } from '../../../libs/i18n/translations';
import { defaultLocale } from '../../../libs/i18n/default';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Pages from '../pages'
import styles from '../../../shared/styles';
import Translate from '../../../shared/components/Translate'

const Layout = ({ user, territory, children }) => {
  const locale = window.I18n.locale || defaultLocale
  const page = useSelector(state => state.page)
  const messages = translations[locale]
  const { layout, container } = styles(page, territory)

  return (
    <IntlProvider locale={locale} key={locale} messages={messages}>
      <div id='guest_signup' style={layout}>
        { page != Pages.ADDRESS_PAGE && (
          <Header
            logoUrl={territory.logo_url}
            logoHeight={territory.logo_height}
            page={page}
            wizard_url={territory.wizard_help_url}
          />
        )}
        <div className="container" style={container}>
          <div className="panel form-container">
            <div className="panel-body">
              {children}
            </div>
          </div>
        </div>
        { page != Pages.ADDRESS_PAGE && <Footer /> }
        <Translate />
      </div>
    </IntlProvider>
  );
}

export default Layout
